import React from 'react';

import styles from './Label.module.css';

type LabelProps = {
  children?: React.ReactNode;
  htmlFor?: string;
  className?: string;
};
export const Label = ({ children, htmlFor, className, ...rest }: LabelProps) => {
  return (
    <label className={className ?? styles.labelStyle} htmlFor={htmlFor} {...rest}>
      {children}
    </label>
  );
};
